import Rest from '@/services/Rest';

/**
 * @typedef {GlobalFlagService}
 */
export default class GlobalFlagService extends Rest {
    /**
     * @type {String}
     */
    static resource = 'global-settings'
}